import { useEffect, useRef } from "react";
import classNames from "classnames";

import { Code, Markdown } from "~/components/shared/StepsEditorSidebar/Markdown";
import { ContentAttribute } from "~/components/shared/StepsEditorSidebar/Guide/useGuide";
import { Highlight } from "~/components/shared/StepsEditorSidebar/useHighlight";

export function GuideAttribute({
  attribute,
  active,
}: {
  attribute: ContentAttribute;
  active?: boolean;
}) {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (active) {
      scrollRef.current?.scrollIntoView({
        block: "center",
      });
    }
  }, [active]);

  return (
    <div ref={scrollRef} className="group space-y-2">
      <h3 className={classNames("m-0 font-mono font-semibold")}>
        <span
          className={classNames(
            active && "bg-green-200 underline decoration-green-700 decoration-2",
          )}
        >
          <Highlight>{attribute.name}</Highlight>
        </span>
      </h3>

      <Markdown
        components={{
          a: "span", // eslint-disable-line id-length
          div: (props) => <Highlight {...props} as="div" className="space-y-2" />,
          code: (props) => <Highlight as={Code} {...props} />,
        }}
      >
        {attribute.textContent}
      </Markdown>
    </div>
  );
}
